
<template>
  <div class="main">
    <!-- 三栏布局 -->
    <div class="headLeft" @click="toHome">京山桥米数字化基地</div>
    <div class="headMid">
      <div
        class="card"
        v-for="item in navTile"
        :key="item.index"
        :style="`background-image: url(${require(`@/assets/images/${item.activate}.png`)})`"
        @click="switchCheck(item)"
      >
        <p :style="item.activate == '已切换' ? 'color: rgb(15, 195, 160)' : ''">
          {{ item.title }}
        </p>
      </div>
    </div>
    <div class="headRight">
      <div class="guanliyuan">
        <!-- &nbsp;&nbsp;&nbsp;&nbsp;{{$store.state.home.townName }} -->
        <select
          v-model="$store.state.home.townName"
          class="selectOptions"
          @change="titlechange"
        >
          <option
            v-for="(option, index) in options"
            :value="option.value"
            class="options"
            :key="index"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
      <div class="tianqi">
        <div class="weather_img">
          <img
            v-if="temperatureLabel == '小雨'"
            class="weatherImg"
            src="@/assets/images/小雨.png"
            alt="weather"
          />
          <img
            v-if="temperatureLabel == '阴'"
            class="weatherImg"
            src="@/assets/images/天气图标_阴.png"
            alt="weather"
          />
          <img
            v-if="
              temperatureLabel == '大雨' ||
              temperatureLabel == '	中到大雨' ||
              temperatureLabel == '小到中雨' ||
              temperatureLabel == '阵雨'
            "
            class="weatherImg"
            src="@/assets/images/天气图标_大雨.png"
            alt="weather"
          />
          <img
            v-if="
              temperatureLabel == '暴雨' ||
              temperatureLabel == '阵雨' ||
              temperatureLabel == '雷阵雨' ||
              temperatureLabel == '大暴雨' ||
              temperatureLabel == '大到暴雨'
            "
            class="weatherImg"
            src="@/assets/images/天气图标_暴雨.png"
            alt="weather"
          />
          <img
            v-if="
              temperatureLabel == '雨夹雪' ||
              temperatureLabel == '阵雪' ||
              temperatureLabel == '小雪' ||
              temperatureLabel == '中雪' ||
              temperatureLabel == '大雪'
            "
            class="weatherImg"
            src="@/assets/images/天气图标_中雪.png"
            alt="weather"
          />
          <img
            v-if="temperatureLabel == '晴'"
            class="weatherImg"
            src="@/assets/images/天气图标_晴.png"
            alt="weather"
          />
          <img
            v-if="temperatureLabel == '刮风'"
            class="weatherImg"
            src="@/assets/images/刮风.png"
            alt="weather"
          />
          <img
            v-if="temperatureLabel == '中雨'"
            class="weatherImg"
            src="@/assets/images/天气图标_中雨.png"
            alt="weather"
          />
          <img
            v-if="temperatureLabel == '多云'"
            class="weatherImg"
            src="@/assets/images/天气图标_多云.png"
            alt="weather"
          />
        </div>
        <div class="weather_display">
          <span class="spanFirst">京 山</span>
          <span class="spanTow"
            >{{ temperature }}℃&nbsp;&nbsp;&nbsp;{{ temperatureLabel }}</span
          >
        </div>
        <div class="day">
          <span class="monthTime">{{ month }}</span>
          <span class="dayTime">{{ day }}</span>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
// import { request } from "@/network/request";
import {
  nextTick,
  onBeforeMount,
  onMounted,
  onUpdated,
} from "@vue/runtime-core";
import { reactive, toRefs } from "@vue/reactivity";
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import emitter from "../../../utils/eventbus";
// import { request } from "@/network/request";

// import { ElMessage } from "element-plus";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  props: [""],
  components: {},
  methods: {
    titlechange() {
      emitter.emit("titlechange");
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      // 主页全部默认
      navTile: [
        {
          index: 1,
          title: "环境监测",
          activate: "默认",
          url: "EnvirMonitor",
        },
        {
          index: 2,
          title: "视频监控",
          activate: "默认",
          url: "Video",
        },
        {
          index: 3,
          title: "溯源大数据",
          activate: "默认",
          url: "http://ybxxfzcx.znglzx.com/#/",
        },
        {
          index: 4,
          title: "智能灌溉",
          activate: "默认",
          // url: "http://121.61.250.38:8088/largeScreen",
          url:"Irrigation"
        },
        // {
        //   index: 5,
        //   title: "虫害测报",
        //   activate: "默认",
        //   url: "http://shuzijiayuan.cn:8899/",
        // },
      ],
      options: [
        { label: "孙桥镇", value: "孙桥镇" },
        { label: "石龙镇", value: "石龙镇" },
      ],
      temperature: "",
      temperatureLabel: "",
    });
    const month = ref("");
    const day = ref("");
    const updateDateTime = () => {
      const now = new Date();
      // 获取月份并转换为指定格式
      const monthStr = (now.getMonth() + 1).toString().padStart(2, "0");
      month.value = `${monthStr}月`;
      // 获取日期并转换为指定格式
      const dayStr = now.getDate().toString().padStart(2, "0");
      day.value = `${dayStr}日`;
    };
    nextTick(() => {});
    onBeforeMount(() => {});
    onMounted(() => {
      // 获取当前url
      let path = window.location.href;
      let pathArr = path.split("/");
      let str = pathArr[pathArr.length - 1];
      // 初始化值
      for (let i = 0; i < state.navTile.length; i++) {
        state.navTile[i].activate = "默认";
      }
      // 给指定切换图片
      switch (str) {
        case "EnvirMonitor":
          state.navTile[0].activate = "已切换";
          break;
        case "Video":
          state.navTile[1].activate = "已切换";
          break;
        default:
          break;
      }
      // 判断vuex中是否有值，有就直接赋值过来
      if (store.state.home.navTile.length > 0) {
        state.navTile = store.state.home.navTile;
      }
      setInterval(updateDateTime, 1000);
      getWeather();
    });
    onUpdated(() => {});
    // 切换页面
    const switchCheck = (item) => {
      // 如果是连接直接开新页面跳转
      if (item.url.slice(0, 4) == "http" || item.url.slice(0, 5) == "https") {
        window.open(item.url);
        return;
      }
      // 其他图片全部加载默认
      for (let i = 0; i < state.navTile.length; i++) {
        state.navTile[i].activate = "默认";
      }
      // 点击到的页面切换图片
      state.navTile[item.index - 1].activate = "已切换";
      router.push({
        name: state.navTile[item.index - 1].url,
      });
      // 更新vuex
      store.commit("home/setnavTile", state.navTile);
      // console.log(state.navTile);
    };
    // 去首页
    const toHome = () => {
      router.push({
        name: "HomePage",
      });
      // 全部设置默认
      for (let i = 0; i < state.navTile.length; i++) {
        state.navTile[i].activate = "默认";
      }
      // 更新vuex
      store.commit("home/setnavTile", state.navTile);
      // console.log(state.navTile);
    };
    // console.log(state.navTile);
    // 获取天气温度
    const getWeather = async () => {
      try {
        const lastVisit = localStorage.getItem("lastVisit"); // 获取上次访问时间
        const today = new Date().toLocaleDateString(); // 获取当前时间
        // console.log("11", today);
        if (lastVisit !== today) {
          const response = await fetch(
            "http://api.yytianqi.com/observe?city=CH201401&key=ec4n7aleupm9wse7"
          );
          const result = await response.json();
          // console.log(result);
          if (result.code === 1) {
            state.temperature = result.data.qw;
            state.temperatureLabel = result.data.tq;
            localStorage.setItem("temperature", state.temperature);
            localStorage.setItem("temperatureLabel", state.temperatureLabel);
            localStorage.setItem("lastVisit", today); // 更新本地存储
          } else {
            console.error(result.msg);
          }
        } else {
          state.temperature = localStorage.getItem("temperature");
          state.temperatureLabel = localStorage.getItem("temperatureLabel");
        }
      } catch (error) {
        console.error(error);
      }
    };

    return {
      ...toRefs(state),
      store,
      router,
      route,
      month,
      day,
      switchCheck,
      toHome,
      getWeather,
    };
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: 6.25rem;
  display: flex;
  align-items: center;

  .headLeft {
    height: 60%;
    width: 21.64%;
    font-size: 2.6rem;
    color: rgb(7, 136, 235);
  }

  .headLeft:hover {
    cursor: pointer;
  }

  .headMid {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .card {
      border: 2px solid transparent;
      width: 18%;
      height: 40%;
      background-size: contain;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        color: rgb(33, 189, 254);
      }
    }

    .card:hover {
      cursor: pointer;
      border: 2px solid rgb(33, 189, 254);
    }
  }

  .headRight {
    display: flex;
    // border: 1px solid red;
    height: 60%;
    width: 21.64%;
    align-items: center;

    .guanliyuan {
      width: 114px;
      height: 40px;
      background-image: url("~@/assets/images/guanliyuan.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      line-height: 40px;

      .selectOptions {
        width: 70px;
        height: 30px;
        position: relative;
        top: 0px;
        right: -15px;
        font-size: 16px;
        color: #fff;
        background-color: transparent;
        border-color: transparent;

        option {
          color: #fff;
          background: #03172f;
          border: none;
        }
      }
    }

    .tianqi {
      width: 220px;
      height: 50px;
      margin-left: 20px;
      line-height: 50px;
      display: flex;
      flex-wrap: nowrap;

      .weather_img {
        width: 50px;
        height: 50px;

        .weatherImg {
          width: 50px;
          height: 50px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }

      .weather_display {
        width: 140px;
        border-right: 1px solid #fff;

        .spanFirst {
          font-size: 18px;
          float: left;
          height: 23px;
          margin-top: -11px;
          margin-left: 7px;
        }
        .spanTow {
          float: left;
          font-size: 13px;
          margin-left: 7px;
        }
      }

      .day {
        width: 100px;

        .monthTime {
          position: relative;
          top: -13px;
          left: 6px;
          font-size: 13px;
        }
        .dayTime {
          position: relative;
          top: 12px;
          left: -25px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>